import { Typography } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import { useEffect, useState } from "react";
import GraphContainer from "../../pages/AnalyticsPage/GraphContainer";

/**
 * Fetches alerts from the JSON file and formats them for the graph
 * @returns Alerts
 */
async function fetchAlerts() {
  try {
    const res = await fetch("data/alerts.json"); // placeholder data
    if (!res.ok)
      console.error("Error fetching alerts, did not return 200 response");
    const json = await res.json();

    // create date objects for the alert times
    const alerts = json.map((alert) => {
      return {
        time: new Date(alert.time),
        alerts: alert.alerts,
      };
    });
    return alerts;
  } catch (error) {
    console.error("Error fetching alerts: ", error);
  }
}

export default function AlertCountGraph() {
  const [alerts, setAlerts] = useState(null);

  useEffect(() => {
    fetchAlerts().then((alerts) => setAlerts(alerts));
  }, []);

  if (!alerts) return <Typography variant="p">Loading...</Typography>;

  return (
    <GraphContainer header={"Alert Count"}>
      <LineChart
        dataset={alerts}
        xAxis={[
          {
            dataKey: "time",
            scaleType: "time",
            tickLabelStyle: {
              angle: -45,
              textAnchor: "end",
            },
          },
        ]}
        series={[{ dataKey: "alerts", curve: "linear", showMark: false }]}
      />
    </GraphContainer>
  );
}
